import React from 'react';
import ReelsContent from '../../assets/images/ReelsContent.png';
import EditingPost from '../../assets/images/EditingPost.png';
import MusicVideosGif from '../../assets/images/MusicVideos.gif';

import VisualisersGif from '../../assets/images/Visualisers.gif';

import { Player } from "@lottiefiles/react-lottie-player";
import VideoCarousel from './OurWorkSection';
import starIconPurple from '../../assets/images/starIcon_purple.png';

const ServicesSection = () => {
  const services = [
    {
      id: 1,
      title: "MUSIC VIDEOS",
   //   image: 'https://res.cloudinary.com/dhjzae1cm/raw/upload/v1755725892/musicVideos_bfcpc7.json', // Space left for image
      image: 'https://res.cloudinary.com/dhjzae1cm/video/upload/v1757166286/MusicVideos_nednvb.mp4',
      // imageType: 'lottie',
      features: [
        {
          title: "Full Music Video Production",
          description: "From concept and locations to shooting and editing.",
          icon: <img src={starIconPurple}  className="w-5 h-5"/>
        },
        {
          title: "Matched to Your Music",
          description: "Visuals crafted to reflect your style and personality.",
          icon: <img src={starIconPurple}  className="w-5 h-5"/>
        }
      ]
    },
    {
      id: 2,
      title: "VISUALISERS",
    //  image: 'https://res.cloudinary.com/dhjzae1cm/raw/upload/v1755725893/visualiser_sj9syo.json',
      image: 'https://res.cloudinary.com/dhjzae1cm/video/upload/v1757166254/Visualisers_cyfflv.mp4',

      // imageType: 'lottie',
      features: [
        {
          title: "Stylized & Animated Visuals",
          description: "Designed to captivate and engage viewers.",
          icon: <img src={starIconPurple}  className="w-5 h-5"/>
        },
        {
          title: "Perfect for Digital Platforms",
          description: "Optimized for streaming and social media impact.",
          icon: <img src={starIconPurple}  className="w-5 h-5"/>
        }
      ]
    },
    {
      id: 3,
      title: "REELS CONTENT",
      image: ReelsContent, // Space left for image
      features: [
        {
          title: "Short-Form Vertical Videos",
          description: "Perfectly sized for Instagram, TikTok, and Shorts.",
          icon: <img src={starIconPurple}  className="w-5 h-5"/>
        },
        {
          title: "Boost Your Song's Reach",
          description: "Optimized to capture attention and grow your audience.",
          icon: <img src={starIconPurple}  className="w-5 h-5"/>
        }
      ]
    },
    {
      id: 4,
      title: "EDITING & POST",
      image: EditingPost, // Space left for image
      features: [
        {
          title: "Professional Post-Production",
          description: "Editing, color grading, and visual effects.",
          icon: <img src={starIconPurple}  className="w-5 h-5"/>
        },
        {
          title: "Premium Cinematic Finish",
          description: "Give your content a polished, high-end look.",
          icon: <img src={starIconPurple}  className="w-5 h-5"/>
        }
      ]
    }
  ];

  return (
    <section className="py-16 lg:py-20 px-4 sm:px-6 lg:px-8 bg-black">
      <div className="max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-[32px] md:gap-[128px] w-full md:w-[70%] mx-auto">
          {services.map((service) => (
            <div key={service.id} className="space-y-6">


              {/* Image - Replace placeholder with actual images */}
              <div className="rounded-xl mb-6 overflow-hidden mx-auto">
                {/* Service Title */}
                <h2 className="text-2xl lg:text-3xl font-normal text-center md:text-left text-white mb-6">
                  {service.title}
                </h2>
                {service.imageType === "lottie" ? (
                  <div className="rounded-xl overflow-hidden mx-auto h-[522px] ">
                    <Player
                      autoplay
                      loop
                      src={service.image}
                      className="w-full h-[360px] md:h-[412px] md:w-[528px] rounded-xl mx-auto md:mx-0 object-cover"
                      />
                  </div>
                  // <Player
                  //   autoplay
                  //   loop
                  //   src={service.image}
                  //   className=" h-[522px] rounded-xl object-cover mx-auto" />
                ) : service.image.endsWith('.webm') || service.image.endsWith('.mp4') ? (
                  <video
                    controls={false}
                    className="w-full h-[360px] md:h-[412px] md:w-[528px] rounded-xl mx-auto md:mx-0 object-cover no-overlay"
                    src={service.image}
                    autoPlay
                    loop
                    muted
                    playsInline
                    preload="metadata"
                  />
                ) : (
                  <img
                    src={service.image}
                    alt={service.title}
                    className="w-full h-[360px] md:h-[400px] md:w-[528px] rounded-xl mx-auto md:mx-0 object-contain"
                    onError={(e) => {
                      console.error(`Failed to load image for ${service.title}:`, service.image);
                      e.target.style.backgroundColor = '#gray-800';
                      e.target.alt = `${service.title} - Image failed to load`;
                    }}
                    onLoad={() => console.log(`Successfully loaded ${service.title} image`)}
                  />)}
              </div>

              {/* Features */}
              <div className="grid sm:grid-cols-2 gap-7">
                {service.features.map((feature, index) => (
                  <div key={index} className="space-y-3">
                    <div className="flex items-start  md:flex-col md:gap-4">
                      <div className="flex-shrink-0 text-[#BA53CE] ">
                        {feature.icon}
                      </div>
                      <div>
                        <h3 className="text-lg font-normal text-white leading-tight mb-2 font-inter">
                          {feature.title}
                        </h3>
                        <p className="text-white/50 text-sm leading-relaxed font-inter">
                          {feature.description}
                        </p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

<VideoCarousel/>

        <div className="h-[400px] mt-16 bg-black-900 rounded-3xl p-8 text-center border border-white/20 flex items-center justify-center flex-col font-inter">
          <h3 className="text-[24px] md:text-[64px] font-semibold text-white mb-4 md:mb-0 font-inter">
            Bring Your Music to Life
          </h3>
          <p className="text-white mb-4 text-[14px] md:text-[20px] font-inter mt-2 md:mt-5">
            Let's create visuals and audio that make your audience feel, remember, and share.
          </p>
          <button className="bg-orange-500 hover:bg-orange-600 text-white font-normal py-4 px-[28px] rounded-xl text-[16px] transition-colors duration-300 max-w-[300px] md:w-auto font-inter mt-6 md:mt-10" onClick={() => window.location.href = '/contact'}>
            Start Your Project
          </button>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
